import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { foldersKeys, RequestTypes } from '@core/react-query/features/folders'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useMoveFolder = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['moveFolder']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...foldersKeys.moveFolder,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: foldersKeys._def,
      })
    },
    ...options,
  })
}
